import React, { Component } from "react";

import BoModal from "../common/BoModal";
import BackofficeService from "../../../services/BackofficeService";
import ClientService from "../../../services/ClientService";
import { I } from "../common/icons";

/**
 * Enrol a client in backoffice: search the firm's clients, pick one, pick the contact its
 * automated emails should go to.
 */
class AddClientModal extends Component {
	state = { search: "", results: [], searching: false, client: null, contacts: [], contactId: "", saving: false, error: null };
	timer = null;

	componentDidMount() {
		this.runSearch("");
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	onSearch = e => {
		const search = e.target.value;
		this.setState({ search });
		clearTimeout(this.timer);
		this.timer = setTimeout(() => this.runSearch(search), 250);
	};

	runSearch = async search => {
		this.setState({ searching: true });
		const response = await ClientService.searchClients({ search });
		const list = response && Array.isArray(response.data) ? response.data : [];
		const enrolled = new Set(this.props.existing.map(c => c.clientId));
		this.setState({ searching: false, results: list.filter(c => !enrolled.has(c.id) && c.name && c.name.trim()).slice(0, 40) });
	};

	pick = async client => {
		this.setState({ client, contacts: [], contactId: "" });
		const result = await BackofficeService.listClientContacts({ clientId: client.id });
		const contacts = result.ok ? result.data : [];
		const primary = contacts.find(c => c.isPrimary) || contacts[0];
		this.setState({ contacts, contactId: primary ? String(primary.id) : "" });
	};

	add = async () => {
		const { client, contactId } = this.state;
		if (!client) return;
		this.setState({ saving: true, error: null });
		const result = await BackofficeService.createClient({ clientId: client.id, contactId: contactId ? parseInt(contactId, 10) : null });
		this.setState({ saving: false });
		if (!result.ok) return this.setState({ error: result.error });
		this.props.onAdded(result.data);
	};

	render() {
		const { onClose } = this.props;
		const s = this.state;
		return (
			<BoModal
				title="Add backoffice client"
				icon={<I.briefcase />}
				onClose={onClose}
				footer={
					<>
						<button className="bo-btn" type="button" onClick={onClose}>
							Cancel
						</button>
						<button className="bo-btn bo-btn--primary ft-bo-client-add" type="button" onClick={this.add} disabled={!s.client || s.saving}>
							{s.saving ? "Adding…" : s.client ? `Add ${s.client.name}` : "Add client"}
						</button>
					</>
				}
			>
				{s.error && <div className="bo-field__error">{s.error}</div>}
				{!s.client && (
					<>
						<div className="bo-field">
							<label>Find a client</label>
							<div className="bo-search" style={{ height: 38 }}>
								<I.search />
								<input type="text" style={{ width: "100%" }} value={s.search} onChange={this.onSearch} placeholder="Search by client name" autoFocus />
							</div>
						</div>
						<div className="bo-client-pick">
							{s.searching && <div className="bo-muted">Searching…</div>}
							{!s.searching && !s.results.length && <div className="bo-muted">No clients found{s.search ? ` for “${s.search}”` : ""}.</div>}
							{s.results.map(c => (
								<button key={c.id} type="button" className="bo-client-pick__item" onClick={() => this.pick(c)}>
									<I.briefcase />
									<b>{c.name}</b>
									<span className="bo-pill bo-pill--grey">{c.type}</span>
								</button>
							))}
						</div>
					</>
				)}
				{s.client && (
					<>
						<div className="bo-acct">
							<I.briefcase />
							<div className="bo-acct__who">
								<b>{s.client.name}</b>
								<span>{s.client.type}</span>
							</div>
							<button className="bo-btn bo-btn--sm" type="button" onClick={() => this.setState({ client: null })}>
								Change
							</button>
						</div>
						<div className="bo-field">
							<label>
								Email contact <small>(where client action emails are sent)</small>
							</label>
							<select value={s.contactId} onChange={e => this.setState({ contactId: e.target.value })}>
								<option value="">{s.contacts.length ? "Use the client's primary contact" : "No contacts on this client"}</option>
								{s.contacts.map(c => (
									<option key={c.id} value={c.id}>
										{[c.name, c.relation, c.email].filter(Boolean).join(" · ")}
									</option>
								))}
							</select>
							{!s.contacts.some(c => c.email) && <div className="bo-callout__note">This client has no contact with an email address, so email automations can't be activated until one is added on the client page.</div>}
						</div>
					</>
				)}
			</BoModal>
		);
	}
}

export default AddClientModal;
